<template>
  <Card class="main-card" :class="classesCard" background="none">
    <div class="main-card__header">
      <div class="main-card__header-left">
        <div>
          <span>День {{ item.number }}</span>
          <svg-icon v-if="isCompleted" name="like" />
        </div>
        <h3>{{ typeTranslate[item.type] }}</h3>
      </div>
      <svg-icon name="tasks/calendar" />
    </div>
    <div class="main-card__body">
      {{ item.points }} {{ item.points | pluralize('очко', 'очка', 'очков') }}
    </div>
    <div class="main-card__footer">
      <div class="main-card__footer-actions" :class="{ 'main-card__footer-actions--lock': isLock }">
        <el-button
          type="primary"
          size="small"
          class="main-card__footer-button"
          @click="redirectToList"
        >
          Перейти к заданиям <svg-icon name="arrow-right" />
        </el-button>
        <svg-icon v-if="isLock" name="lock" />
      </div>
      <div class="main-card__footer-progress">
        <Progress :percentage="50" />
        <span>80 из {{ item.points }} {{ item.points | pluralize('очко', 'очка', 'очков') }}</span>
      </div>
    </div>
  </Card>
</template>

<script>
import Card from '@/components/Common/Card'
import Progress from '@/components/Common/Progress'

export default {
  name: 'MainCard',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    classesCard() {
      return [`main-card--${this.item.type}`, `main-card--${this.item.status}`]
    },

    isCompleted() {
      return this.item.status === 2
    },

    isLock() {
      return this.item.status === 0
    },

    typeTranslate() {
      return {
        letters: 'Буквы',
        material: 'Звук',
        content: 'Говорим',
        test: 'Пишем'
      }
    }
  },

  methods: {
    redirectToList() {
      this.$router.push({
        name: 'studentEducationList',
        params: {
          id: this.item.id
        }
      })
    }
  },

  components: {
    Card,
    Progress
  }
}
</script>

<style scoped lang="scss">
.main-card {
  transition: 0.3s;
  box-shadow: none !important;
  background-repeat: no-repeat;
  background-color: $white;
  background-position: -55px -10px;
  background-size: 110%;
  background-image: url('/img/calendar-background.svg?v=2');

  &--0 &__header {
    &-left {
      span {
        box-shadow: none;
        background: $whisper;
        color: $french-gray;
      }
    }

    & > svg::v-deep {
      .background {
        fill: $whisper;
      }

      .content {
        fill: $french-gray;
      }
    }
  }

  &--1 {
    border: 2px solid $luchmara;
  }

  &--1 &__header {
    &-left {
      span {
        box-shadow: 0 4px 16px rgba($green, 0.4);
        background: $green;
      }
    }

    & > svg::v-deep {
      box-shadow: 0 4px 16px rgba($luchmara, 0.4);

      .background {
        fill: $luchmara;
      }

      .content {
        fill: $whisper;
      }
    }
  }

  &--2 &__header {
    &-left {
      span {
        box-shadow: 0 4px 16px rgba($cream-can, 0.4);
        background: $cream-can;
      }
    }

    & > svg::v-deep {
      box-shadow: 0 4px 16px rgba($cream-can, 0.4);

      .background {
        fill: $cream-can;
      }

      .content {
        fill: $whisper;
      }
    }
  }

  &__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    & > svg {
      width: 112px;
      height: 112px;
      border-radius: 16px;

      @include md-and-down {
        width: 56px;
        height: 56px;
      }
    }

    &-left {
      display: flex;
      align-items: flex-start;
      flex-direction: column;

      & > h3 {
        margin-top: 24px;
        font-weight: 500;
        font-size: 24px;
        color: $deepdark;
        text-transform: uppercase;
      }

      span {
        font-weight: 500;
        border-radius: 12px;
        font-size: 13px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: $white;
        width: 64px;
        height: 32px;
      }

      & > div {
        display: flex;
        align-items: center;
      }

      svg {
        margin-left: 8px;
        width: 32px;
        height: 32px;
        background: $cream-can;
        box-shadow: 0 4px 16px rgba($cream-can, 0.4);
        border-radius: 12px;
        stroke: $white;
      }
    }
  }

  &__body {
    margin: 12px 0 56px;
    font-weight: 500;
    font-size: 24px;
    color: $luchmara;

    @include md-and-down {
      margin: 24px 0;
      font-size: 20px;
    }
  }

  &__footer {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    &-button::v-deep span {
      display: flex;
      align-items: center;

      svg {
        width: 5px;
        height: 10px;
        stroke: $white;
        margin-left: 20px;
        margin-right: -8px;
      }
    }

    &-actions {
      display: flex;
      align-items: center;

      &--lock {
        button {
          border: 0;
          pointer-events: none;
          color: $manatee;
          background: $whisper;

          &::v-deep span svg {
            stroke: $manatee;
          }
        }

        & > svg {
          flex-shrink: 0;
          width: 32px;
          height: 32px;
          background: $whisper;
          border-radius: 12px;
          fill: $manatee;
          margin-left: 8px;
        }
      }
    }

    &-progress {
      margin-top: 16px;
      display: flex;
      align-items: center;
      width: 100%;

      span {
        white-space: nowrap;
        margin-left: 16px;
        font-size: 13px;
        color: $luchmara;
        margin-right: 24px;
      }
    }
  }
}
</style>
